module.exports = __webpack_public_path__ + "static/media/dinosaurT1.eb5a4745.jpg";